import { render } from "./SignBody.vue?vue&type=template&id=4d9f19fa&scoped=true"
import script from "./SignBody.js?vue&type=script&lang=js"
export * from "./SignBody.js?vue&type=script&lang=js"

import "./SignBody.css?vue&type=style&index=0&id=4d9f19fa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9f19fa"]])

export default __exports__